import React from 'react'

export default function MiniLogo() {
    return (
        <svg id="uuid-d6fcf388-bb75-4f72-8c2a-c53fdc392822" data-name="Livello 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 591.78 155.16">
  <g id="uuid-23645d02-e79f-461c-a638-d12839f581d2" data-name="Livello 1">
    <g transform="translate(195,0)">
      <path fill='#6237fb'  d="M160.6,66.88c1.18-6.24,1.25-12.56,1.12-18.9,35.08,10.61,49.97,52.68,28.86,83.13-21.31,30.74-55.45,23.09-87.75,23.11-33.88.02-74.24,8.51-94.82-25.87-25.57-42.7,14.11-94.24,61.87-80.78,6.94,1.96,21.55,9.4,24.91,15.88,4.55,8.77-5.2,17.23-13.74,11.43-8.47-5.76-11.5-10.16-23.16-11.32-47.28-4.73-54.89,69.17-5.67,72.87,31.07-1.49,64.01,2,94.86.03,39.07-2.5,48.28-53.4,13.52-69.58Z"/>
      <path fill='#170624' d="M151.95,128.97c-6.16.72-12.37.71-18.59.49-5.56-9.21-12.89-16.12-23.51-19.01-3.83-1.04-11.35-1.08-13.81-2.28-4.31-2.1-6.18-8.09-3.98-12.33,3.11-6,10.54-4.49,16.12-5.72,13.79-3.03,26.47-15.66,28.1-29.94,4.86-42.68-50.67-58.41-68.91-20.9-6.28.25-12.61-2.32-18.87-.48C52.72,20.6,69.96,4.99,88.24,1.26c55.73-11.36,90,56.77,47.62,94.69-.8.72-5.17,3.57-5.17,4.01,9.71,7.26,18.23,16.98,21.26,29Z"/>
    </g>
  </g>
</svg>

    )
}
